export function updateProgressBar(currentTurn) {
    // update partno div
    var partno = document.getElementById('partno');
    if(currentTurn === 1) {
      partno.innerHTML = "This interview is comprised of 3 parts.";
    } else {
      partno.innerHTML = "Part " + (currentTurn-1) + " of 3";
    }
    

    // Iterate over each step
    for (let i = 1; i <= 4; i++) {
      const stepElement = document.getElementById(`step-${i}`);
      
      // Clear the element to rebuild it
      stepElement.innerHTML = '';
      
      // Determine the state of the step and apply the corresponding classes
      if (i < currentTurn) {
          // Completed Step
          stepElement.innerHTML = getCompletedStepMarkup(i);
      } else if (i === currentTurn) {
          // Current Step
          stepElement.innerHTML = getCurrentStepMarkup(i);
      } else {
          // Upcoming Step
          stepElement.innerHTML = getUpcomingStepMarkup(i);
      }
    }
  }

  function getCompletedStepMarkup(stepNumber) {
      // Determine the state of the step and apply the corresponding classes
      if (stepNumber === 4) {
          // last turn
          return `
          <a href="#" class="relative flex h-8 w-8 items-center justify-center rounded-full bg-indigo-600 hover:bg-indigo-900">
              <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
              </svg>
              <span class="sr-only">Step ${stepNumber}</span>
          </a>
          `;
      } else if (stepNumber < 4) {
          // not the last turn
          return `
          <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="h-0.5 w-full bg-indigo-600"></div>
          </div>
          <a href="#" class="relative flex h-8 w-8 items-center justify-center rounded-full bg-indigo-600 hover:bg-indigo-900">
              <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
              </svg>
              <span class="sr-only">Step ${stepNumber}</span>
          </a>
          `;
      } 
      
  }

  function getCurrentStepMarkup(stepNumber) {
      if (stepNumber === 4) {
          // last turn
          return `
          <a href="#" class="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-indigo-600 bg-white" aria-current="step">
              <span class="h-2.5 w-2.5 rounded-full bg-indigo-600" aria-hidden="true"></span>
              <span class="sr-only">Step ${stepNumber}</span>
          </a>
          `;
      } else if (stepNumber < 4) {
          // not the last turn
          return `
          <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="h-0.5 w-full border-gray-300 bg-gray-300"></div>
          </div>
          <a href="#" class="relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-indigo-600 bg-white" aria-current="step">
              <span class="h-2.5 w-2.5 rounded-full bg-indigo-600" aria-hidden="true"></span>
              <span class="sr-only">Step ${stepNumber}</span>
          </a>
          `;
      } 
      
  }

  function getUpcomingStepMarkup(stepNumber) {
      if (stepNumber === 4) {
          // last turn
          return `
          <a href="#" class="group relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white hover:border-gray-400">
              <span class="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300" aria-hidden="true"></span>
              <span class="sr-only">Step ${stepNumber}</span>
          </a>
          `;
      } else if (stepNumber < 4) {
          // not the last turn
          return `
          <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="h-0.5 w-full  border-gray-300 bg-gray-300"></div>
          </div>
          <a href="#" class="group relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white hover:border-gray-400">
              <span class="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300" aria-hidden="true"></span>
              <span class="sr-only">Step ${stepNumber}</span>
          </a>
          `;
      } 
      
  }